import { fmtAmount } from '../lib/format';
import type { Promotion } from '../types/domain';

export function PromoPreviewCard({
  promo,
}: {
  promo: Pick<Promotion, 'name' | 'type' | 'value' | 'minQty'>;
}) {
  const badge =
    promo.type === 'percent' || promo.type === 'bill_percent'
      ? `-${promo.value}%`
      : promo.type === 'baht'
        ? `-฿${fmtAmount(promo.value)}`
        : promo.type === 'fixed_price'
          ? `฿${fmtAmount(promo.value)}/ชิ้น`
          : promo.type === 'qty_tier'
            ? `${promo.minQty ?? 0} ชิ้น -฿${fmtAmount(promo.value)}`
            : `${Math.max(1, (promo.minQty ?? 2) - Math.max(1, Math.floor(promo.value || 1)))}+${Math.max(1, Math.floor(promo.value || 1))}`;
  return (
    <div className="bo-card p-4 w-[280px] bg-primary-light border-primary/30">
      <div className="text-sm-label text-ink-3 mb-2">ตัวอย่างบนจอ POS</div>
      <div className="rounded-card bg-surface border border-line p-4 flex items-center gap-3">
        <span className="num text-h2 font-bold text-primary">{badge}</span>
        <span className="text-body font-semibold text-ink">
          {promo.name || 'ชื่อโปรโมชั่น'}
        </span>
      </div>
    </div>
  );
}
